import React, { useState, useEffect } from "react";
import http from "../../../../services/http";
import { Link } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
import { EditOutlined, DeleteOutlined, SearchOutlined } from "@mui/icons-material";
import { Button, Input, Table } from "antd";
import { IMAGE_HOST } from "../../../../constant";
import moment from "moment";
import DeleteBlogModal from "./delete-blog";
import "./styles.scss";

function Blogs() {
  // STATES
  const [blogsLoader, setBlogsLoader] = useState(true);
  const [deleteBlogPreview, setDeleteBlogPreview] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [blogs, setBlogs] = useState([]);
  const [searchTerm, setSearchTerm] = useState(""); // <-- NEW

  // HELPERS
  const getBlogsHelper = async () => {
    setBlogsLoader(true);
    const { data } = await http.get(`admin-blog`);
    setBlogs(data);
    setBlogsLoader(false);
  };

  // HANDLERS
  const deleteBlogPreviewHandler = (data) => {
    setDeleteBlogPreview(true);
    setSelectedBlog(data);
  };

  const deleteBlogSuccessHandler = (id) => {
    setBlogs(blogs.filter((blog) => blog.id !== id));
    setSelectedBlog(null);
  };

  // Filter blogs by title based on search term  <-- NEW
  const filteredBlogs = blogs.filter((blog) =>
    blog.title?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // CONST VALS
  const columns = [
    {
      title: "Title",
      dataIndex: "",
      key: "title",
      render: (data) => (
        <span className="title-cell">
          <span className="thumbnail">
            <img src={IMAGE_HOST + data.thumbnail} alt={data.title} />
          </span>
          <span className="title">{data.title}</span>
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "is_published",
      key: "is_published",
      render: (is_published) => (
        <span className={`status-tag ${is_published ? "published" : "draft"}`}>
          {is_published ? "Published" : "Draft"}
        </span>
      ),
    },
    {
      title: "Author",
      dataIndex: "",
      key: "author",
      render: (data) => {
        const authorName = data.author_name || data.author?.username || "Grayson Rothchild";
        const authorImage =
          IMAGE_HOST + (data.author_image || "blog/authors/default.png");
        return (
          <span className="author-cell">
            <span className="author-avatar">
              <img src={authorImage} alt={authorName} />
            </span>
            <span className="author-name">{authorName}</span>
          </span>
        );
      },
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (created_at) => <span>{moment(created_at).format("DD/MM/YYYY")}</span>,
    },
    {
      title: "Updated At",
      dataIndex: "updated_at",
      key: "updated_at",
      render: (updated_at) => <span>{moment(updated_at).format("DD/MM/YYYY")}</span>,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <span className="actions-cell">
          <Link className="edit-btn" to={`/blogs/edit/${record.id}`}>
            <EditOutlined />
          </Link>
          <button className="delete-btn" onClick={() => deleteBlogPreviewHandler(record)}>
            <DeleteOutlined />
          </button>
        </span>
      ),
    },
  ];

  // HOOKS
  useEffect(() => {
    setBlogs([]);
    getBlogsHelper();
  }, []);

  return (
    <div className="blogs-wrapper">
      <h2 className="page-title">Blogs</h2>

      <div className="blogs-listing">
        <div className="top-header">
          <div className={`input-box`}>
            <span className="prefix">
              <SearchOutlined />
            </span>
            <Input
              value={searchTerm}
              placeholder="Search by name"
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <Link to="/blogs/create">
            <Button type="primary" className="btn btn-primary" icon={<PlusOutlined />}>
              Add Blog
            </Button>
          </Link>
        </div>
        <Table dataSource={filteredBlogs} columns={columns} loading={blogsLoader} />
      </div>
      <DeleteBlogModal
        preview={deleteBlogPreview}
        selectedBlog={selectedBlog}
        previewHandler={() => setDeleteBlogPreview(false)}
        successHandler={deleteBlogSuccessHandler}
      />
    </div>
  );
}

export default Blogs;
